import { GAME_CONFIG } from '../config/gameConfig';
import type { MatchSetup } from '../sim/match';
import { DEFAULT_STARTING_BUILDINGS } from '../sim/match';
import { MODES } from '../sim/modes/modes';
import { Simulation } from '../sim/Simulation';
import { generateMap } from '../world/mapGenerator';
import type { MatchStart } from './protocol';

/**
 * Build the Simulation for an online match from its start message. The client
 * and the server both call this, so they hold identical state (same seed, map,
 * players, mode). Engine-free.
 */
export function createMatchSim(start: MatchStart, localPlayer?: string): Simulation {
  const mode = MODES[start.options.mode];
  const dev = start.options.dev;
  const map = generateMap({ ...GAME_CONFIG.map, width: start.map.width, height: start.map.height, seed: start.seed });
  const setup: MatchSetup = {
    players: start.players.map((p) => ({ id: p.id, name: p.name, slot: p.slot, team: p.team, control: p.id === localPlayer ? 'local' : 'remote' })),
    startingBuildings: DEFAULT_STARTING_BUILDINGS,
  };
  return new Simulation(map, setup, {
    mode,
    buildRadius: GAME_CONFIG.colony.buildRadius,
    startingUnits: dev?.units,
    ...(start.base ? { raid: { base: start.base } } : {}),
    ...(start.unlocks ? { unlocks: start.unlocks } : {}),
    infected: {
      ...mode.infected,
      seed: start.seed,
      ...(dev?.zombies !== undefined ? { initial: dev.zombies } : {}),
      ...(dev?.waves !== undefined ? { waves: dev.waves } : {}),
    },
  });
}
